import React from 'react';
import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonMenuToggle,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonButton
} from '@ionic/react';
import Subscribe from 'src/components/Subscribe';
import personalInfoImg from 'src/images/personal-info.svg';
import app from 'src/feathers';

export default () => (
  <Subscribe
    render={(container) => {
      const { user } = container.state;
      return (
        <IonMenu
          side="start"
          menuId="mainMenu"
          contentId="mainContent"
          type="push"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Menu</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonList>
              <IonMenuToggle>
                <IonItem routerLink="/jobs">Jobs</IonItem>
              </IonMenuToggle>
              <IonMenuToggle>
                <IonItem routerLink="/stats">Stats</IonItem>
              </IonMenuToggle>
              {/* <IonMenuToggle>
          <IonItem routerLink="/profile">Profile</IonItem>
        </IonMenuToggle>
        <IonItem>Logout</IonItem> */}
            </IonList>

            <div
              className="ion-padding"
              style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
            >
              {user && <h2>{user.full_name}</h2>}
              <img
                src={personalInfoImg}
                className="mb-4"
                alt="Personal Info"
                style={{ transform: 'scaleX(-1)' }}
              />
              <div className="d-flex justify-content-between">
                <IonMenuToggle>
                  <IonButton routerLink="/profile">Edit Profile</IonButton>
                </IonMenuToggle>
                <IonButton color="light" onClick={app.logout}>
                  Logout
                </IonButton>
              </div>
            </div>
          </IonContent>
        </IonMenu>
      );
    }}
  />
);
